import { NgModule } from '@angular/core';
import { EmpusaMicroAppType } from '@empusa/empusa-core';
import { PackagingWasteManagementHomeModule } from './packaging-waste-management-home.module';

@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class PackagingWasteManagementModule {
  name: string = "packaging-waste-management";
  description: string = "Gestión de residuos de envases"
  icon: string = "packaging-waste-management";
  page: any = PackagingWasteManagementHomeModule;
  homeApp: boolean = false;
  path: string = "packaging-waste-management";
  order: number = 1;
  resourceServerId: string = "keycloak-auth-manager-resources-server";
  appType: EmpusaMicroAppType = EmpusaMicroAppType.home;

  constructor() {
    //we register ourselves
    (<any>window).empusa(this);
    console.debug("Load microapp " + this.name);
  }
 }
